module.exports = __webpack_public_path__ + "img/calling.87d22f56.svg";